import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_SHOPMANAGEMENTSEARCH_REQUEST = 'tube/orders/store/FETCH_SHOPMANAGEMENTSEARCH_REQUEST';
const FETCH_SHOPMANAGEMENTSEARCH_SUCCESS = 'tube/orders/store/FETCH_SHOPMANAGEMENTSEARCH_SUCCESS';
const FETCH_SHOPMANAGEMENTSEARCH_ERROR = 'tube/orders/store/FETCH_SHOPMANAGEMENTSEARCH_ERROR';

const FETCH_SHOPMANAGEMENTDATA_REQUEST = 'tube/orders/store/FETCH_SHOPMANAGEMENTDATA_REQUEST';
const FETCH_SHOPMANAGEMENTDATA_SUCCESS = 'tube/orders/store/FETCH_SHOPMANAGEMENTDATA_SUCCESS';
const FETCH_SHOPMANAGEMENTDATA_ERROR = 'tube/orders/store/FETCH_SHOPMANAGEMENTDATA_ERROR';

const DELETE_SHOPMANAGEMENT_REQUEST = 'tube/orders/store/DELETE_SHOPMANAGEMENT_REQUEST';
const DELETE_SHOPMANAGEMENT_SUCCESS = 'tube/orders/store/DELETE_SHOPMANAGEMENT_SUCCESS';
const DELETE_SHOPMANAGEMENT_ERROR = 'tube/orders/store/DELETE_SHOPMANAGEMENT_ERROR';

const POST_SHOPMANAGEMENT_REQUEST = 'tube/orders/store/POST_SHOPMANAGEMENT_REQUEST';
const POST_SHOPMANAGEMENT_SUCCESS = 'tube/orders/store/POST_SHOPMANAGEMENT_SUCCESS';
const POST_SHOPMANAGEMENT_ERROR = 'tube/orders/store/POST_SHOPMANAGEMENT_ERROR';

const PUT_SHOPMANAGEMENT_REQUEST = 'tube/orders/store/PUT_SHOPMANAGEMENT_REQUEST';
const PUT_SHOPMANAGEMENT_SUCCESS = 'tube/orders/store/PUT_SHOPMANAGEMENT_SUCCESS';
const PUT_SHOPMANAGEMENT_ERROR = 'tube/orders/store/PUT_SHOPMANAGEMENT_ERROR';

export default function reducer(state = {
  shopManagementList: {
    isLoadingShopManagement: false,
    data: [],
    meta: {},
  },
  shopManagementData: {
    isLoadingShopManagementData: false,
    data: [],
    meta: {},
  },
}, action) {
  switch (action.type) {
    case FETCH_SHOPMANAGEMENTSEARCH_REQUEST:
      return Object.assign({}, state, {
        shopManagementList: {
          isLoadingShopManagement: true,
        },
      });
    case FETCH_SHOPMANAGEMENTSEARCH_SUCCESS:
      return Object.assign({}, state, {
        shopManagementList: {
          isLoadingShopManagement: false,
          data: action.response.data,
          meta: action.response.meta,
        },
      });
    case FETCH_SHOPMANAGEMENTDATA_REQUEST:
      return Object.assign({}, state, {
        shopManagementData: {
          isLoadingShopManagementData: true,
        },
      });
    case FETCH_SHOPMANAGEMENTDATA_SUCCESS:
      return Object.assign({}, state, {
        shopManagementData: {
          isLoadingShopManagementData: false,
          data: action.response.data,
          meta: action.response.meta,
        },
      });
    default:
      return state;
  }
}

// 列表
export function fetchShopManagementSearch(paramsData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/ShopManagement/ShopSearch',
      method: 'GET',
      types: [
        FETCH_SHOPMANAGEMENTSEARCH_REQUEST,
        FETCH_SHOPMANAGEMENTSEARCH_SUCCESS,
        FETCH_SHOPMANAGEMENTSEARCH_ERROR,
      ],
      params: paramsData,
    },
  };
}

// 單筆
export function fetchShopManagementData(shopId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Ordering/ShopManagement/${shopId}`,
      method: 'GET',
      types: [
        FETCH_SHOPMANAGEMENTDATA_REQUEST,
        FETCH_SHOPMANAGEMENTDATA_SUCCESS,
        FETCH_SHOPMANAGEMENTDATA_ERROR,
      ],
    },
  };
}

// 刪除
export function deleteShopManagement(shopId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Ordering/ShopManagement/${shopId}`,
      method: 'DELETE',
      types: [
        DELETE_SHOPMANAGEMENT_REQUEST,
        DELETE_SHOPMANAGEMENT_SUCCESS,
        DELETE_SHOPMANAGEMENT_ERROR,
      ],
    },
  };
}

// 新增店家
export function postShopManagement(shopData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Ordering/ShopManagement`,
      method: 'POST',
      types: [
        POST_SHOPMANAGEMENT_REQUEST,
        POST_SHOPMANAGEMENT_SUCCESS,
        POST_SHOPMANAGEMENT_ERROR,
      ],
      params: shopData,
    },
  };
}

// 修改店家
export function putShopManagement(shopData, shopId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Ordering/ShopManagement/${shopId}`,
      method: 'PUT',
      types: [
        PUT_SHOPMANAGEMENT_REQUEST,
        PUT_SHOPMANAGEMENT_SUCCESS,
        PUT_SHOPMANAGEMENT_ERROR,
      ],
      params: shopData,
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Orders/screens/Store/reducers/index.js
 **/